import { FulfillmentFlatTeamSettingCatalogDefinitions as originalFulfillmentDefinitions } from "../../flat-team-settings/fulfillment/catalog";
import { FulfillmentFlatTeamSettingCatalogDefinitions } from "../../flat-team-settings/fulfillment/catalog-shipping-new";
import { FulfillmentFlatTeamSettingGroups as originalFulfillmentGroups } from "../../flat-team-settings/fulfillment/groups";
import { FulfillmentFlatTeamSettingGroups } from "../../flat-team-settings/fulfillment/groups-shipping-new";
import { InternationalMarketsEditorFlatTeamSettingCatalogDefinitions } from "../../flat-team-settings/international-markets-editor/catalog";
import { ReturnsFlatTeamSettingCatalogDefinitions as originalReturnsDefinitions } from "../../flat-team-settings/returns/catalog";
import { ReturnsFlatTeamSettingCatalogDefinitions } from "../../flat-team-settings/returns/catalog-shipping-new";
import { ShippingFulfillmentPromiseFlatTeamSettingCatalogDefinitions as originalPromiseDefinitions } from "../../flat-team-settings/shipping-fulfillment-promise/catalog";
import { ShippingFulfillmentPromiseFlatTeamSettingCatalogDefinitions } from "../../flat-team-settings/shipping-fulfillment-promise/catalog-shipping-new";
import { ShippingFulfillmentPromiseFlatTeamSettingGroups as originalPromiseGroups } from "../../flat-team-settings/shipping-fulfillment-promise/groups";
import { ShippingFulfillmentPromiseFlatTeamSettingGroups } from "../../flat-team-settings/shipping-fulfillment-promise/groups-shipping-new";
import { defineSettingsProvider } from "../provider";
import type { SettingDefinition, SettingGroupDefinition } from "../types";
import { FlatTeamSettingsCatalogProvider as originalProvider } from "./flat-team-settings";

function replaceCatalogEntries<T extends { id: string }>(
  entries: readonly T[],
  original: readonly T[],
  replacement: readonly T[],
): T[] {
  const replacedIds = new Set(original.map((entry) => entry.id));
  const firstId = original[0]?.id;
  return entries.flatMap((entry) =>
    entry.id === firstId
      ? [...replacement]
      : replacedIds.has(entry.id)
        ? []
        : [entry],
  );
}

export const FlatTeamSettingsCatalogProvider = defineSettingsProvider({
  name: originalProvider.name,
  groups: replaceCatalogEntries<SettingGroupDefinition>(
    replaceCatalogEntries<SettingGroupDefinition>(
      originalProvider.groups,
      originalFulfillmentGroups,
      FulfillmentFlatTeamSettingGroups,
    ),
    originalPromiseGroups,
    ShippingFulfillmentPromiseFlatTeamSettingGroups,
  ),
  definitions: replaceCatalogEntries<SettingDefinition>(
    replaceCatalogEntries<SettingDefinition>(
      replaceCatalogEntries<SettingDefinition>(
        originalProvider.definitions,
        originalFulfillmentDefinitions,
        [
          ...InternationalMarketsEditorFlatTeamSettingCatalogDefinitions,
          ...FulfillmentFlatTeamSettingCatalogDefinitions,
        ],
      ),
      originalPromiseDefinitions,
      ShippingFulfillmentPromiseFlatTeamSettingCatalogDefinitions,
    ),
    originalReturnsDefinitions,
    ReturnsFlatTeamSettingCatalogDefinitions,
  ),
});

export const FlatTeamSettingsCatalogGroups =
  FlatTeamSettingsCatalogProvider.groups;
export const FlatTeamSettingsCatalogDefinitions =
  FlatTeamSettingsCatalogProvider.definitions;
